<div class="col-xl">
    <div class="card mb-4">
        <div class="card-body">

            <input #unitCsvInput type="file" accept=".csv,text/csv" style="display:none"
                (change)="onCsvSelected($event)" />

            <!-- External filters + Acciones -->
            <div class="row g-3 mb-3 align-items-end">
                <div class="col-md-3">
                    <label class="filter-label">Unidad</label>
                    <select class="form-select filter-control" [(ngModel)]="filterUnit"
                        (ngModelChange)="onFilterChange()">
                        <option value="">Seleccionar</option>
                        <option *ngFor="let u of unitOptions" [value]="u">{{u}}</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label class="filter-label">Placas</label>
                    <input type="text" class="form-control filter-control" placeholder="Ingresar"
                        [(ngModel)]="filterPlates" (ngModelChange)="onFilterChange()">
                </div>
                <div class="col-md-3">
                    <label class="filter-label">Disponibilidad</label>
                    <select class="form-select filter-control" [(ngModel)]="filterDisponibilidad"
                        (ngModelChange)="onFilterChange()">
                        <option value="">Seleccionar</option>
                        <option *ngFor="let d of disponibilidadOptions" [value]="d">{{d}}</option>
                    </select>
                </div>
                <div class="col-md-3 d-flex justify-content-end">
                    <div class="btn-group" [class.show]="actionsOpen" (click)="$event.stopPropagation()">
                        <button type="button" class="btn btn-outline-primary d-flex align-items-center gap-2"
                            style="border-radius: 50px; padding: 8px 20px;"
                            (click)="$event.stopPropagation(); toggleActionsDropdown()"
                            [attr.aria-expanded]="actionsOpen ? 'true' : 'false'">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                fill="none">
                                <circle cx="12" cy="5" r="1.8" fill="#00A0E1" />
                                <circle cx="12" cy="12" r="1.8" fill="#00A0E1" />
                                <circle cx="12" cy="19" r="1.8" fill="#00A0E1" />
                            </svg>
                            Opciones
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end unit-actions-menu" [class.show]="actionsOpen"
                            (click)="$event.stopPropagation(); closeActionsDropdown()">
                            <li>
                                <button class="dropdown-item" type="button"
                                    (click)="openCsvPicker(unitCsvInput)">Importar CSV</button>
                            </li>
                            <li>
                                <button class="dropdown-item" type="button" (click)="exportCsv()">Exportar CSV</button>
                            </li>
                            <li>
                                <button class="dropdown-item" type="button" (click)="exportPermitTypesCsv()">Exportar
                                    tipos de permiso</button>
                            </li>
                            <li>
                                <button class="dropdown-item" type="button"
                                    (click)="exportVehicleConfigurationsCsv()">Exportar configuración vehicular</button>
                            </li>
                            <li>
                                <button class="dropdown-item" type="button" (click)="exportInsurersCsv()">Exportar
                                    aseguradoras</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- AG Grid -->
            <ag-grid-angular style="width: 100%; height: 60vh;" class="ag-theme-alpine" [columnDefs]="columnDefs"
                [defaultColDef]="defaultColDef" [rowData]="rowData" [animateRows]="true"
                [loadingCellRenderer]="loadingCellRenderer" [loadingCellRendererParams]="loadingCellRendererParams"
                [isExternalFilterPresent]="isExternalFilterPresent" [doesExternalFilterPass]="doesExternalFilterPass"
                (gridReady)="onGridReady($event)">
            </ag-grid-angular>

        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>